import React, { useState, useEffect } from "react";
import axios from 'axios';
import AuthService from '../Auth/AuthService.js';
//import settings from './../Settings.json';
import { settings } from './../Helpers/Settings.js';
import { NavLink, useLocation } from 'react-router-dom';
import { isExpired } from "react-jwt";

const PageTitle = () => {
    const location = useLocation();
    const [data, setData] = useState('');

    useEffect(() => {
        getData();

    }, [location]);

    const getData = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === false) {
            let currentLocation = window.location.pathname.replaceAll("/", "~");

            try {
                const res = await axios.get(settings.ApiUrl + 'Rol/GetPageTitle/' + currentLocation, { headers: AuthService.getHeaders() });
    
                if (res.data) {
                    setData(res.data.value);
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    return (
        <div>
            {
                data ?
                    <div className="pagetitle">
                        {/* <h1>{currentPage}</h1> */}
                        <nav>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <NavLink to="/home">
                                        Ana sayfa
                                    </NavLink>
                                </li>
                                <li className="breadcrumb-item">{data.folder}</li>
                                <li className="breadcrumb-item active">{data.page}</li>
                            </ol>
                        </nav>
                    </div>
                    :
                    ''
            }
        </div>
    )
}

export default PageTitle;